/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VuePdfEmbed from "vue-pdf-embed";
import Modal from "../modal/modal.vue"; // Add this import
import jwt_decode from "jwt-decode";
export default {
  name: "ConsentSubjectSign",
  components: { VuePdfEmbed, Modal }, // Add Modal to components
  props: {
    patientLoginId: { type: String, default: "" },
    templateId: { type: String, default: "" },
    consentFormId: { type: String, default: "" },
    documentId: { type: String, default: "" }
  },
  data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      currentStep: 1,
      activeTab: "doc",
      timelineSteps: [
        { status: "active", lineStatus: "" },
        { status: "", lineStatus: "" },
        { status: "", lineStatus: "" }
      ],
      dissentReasonError: false,
      // Account
      values: {
        firstName: "",
        lastName: "",
        userName: "",
        emailIdPrimary: "",
        password: "",
       timeZone:"",
       preferredLanguage:"",  
      },
      videoViewedEventSent: false,
      documentViewedEventSent: false,
      isSigning: false,
      isSubmittingNoConsent: false,
       consentRecordId: "",
       videoModalVisible: false,
      selectedVideo: null,
      newpassword: "",
      visibleOn: false,
      inputType: "password",
      errors: [true, true, true, true, true, true, true, true],
      validations: [true, true, true, true, true, true, true, true],
      accountLoading: false,
      // Video - Add modal properties
      videoProgress: 0,
      videoCompleted: false,
      videoTimer: null,
      videoStatusText: "Enrollment walkthrough · 4:32",
      vidWatched: false,
      vidPct: 0,
      videolist: [],
      isLoading: false,
      showModal: false, // Add this
      modalType: "", // Add this
      modelvideoId: "", // Add this
      versionId: "", // Add this
      Id: "", // Add this
      ReferenceId: "", // Add this
      // Document
      documentlist: [],
      selectedIcfDocumentSource: "",
      selectedIcfDocumentObjectUrl: "",
      isIcfDocumentLoading: false,
      icfDocumentError: "",
      docCompleted: false,
      docRead: false,
      documentName: "",
      docProgressValue: 0,
      pageIndicator: "Page 1 of 7",
      isDocumentLoading: false,
      // Consent
      consentChecks: {
        readComprehend: false,
        voluntary: false,
        copyReceived: false,
        healthInfo: false
      },
      consentAgreed: null,
      signingReason:"",
      noConsentSubmitted: false,
      consentSigned: false,
      alreadySignedFromHistory: false,
      subjectSignedAt: "",
      subjectSignedAtText: "",
      consentResponseType: "",
      consentResponseAt: "",
      consentResponseAtText: "",
       //signingReason: "I voluntarily consent to participate in the study.",
    showSigningReason: false,
      signature: { email: "", password: "" },
      canSign: false,
      // Backend datap
      patientInfo: null,
      patientLogin: {},
      patientItem: {},
      studyId: "",
      subjectId: "",
      icfFormId: "",
      description: "",
      isDescLoading: false,
      isVideoLoading: false,
      studyDescription: "",
      isConsent: true,
      status: "",
      currentformid: "",
      // Pagination for documents
      pageindex: 1,
      pagesize: 10,
      SortProperty: "CreatedAt",
      SortOrder: 1,
      hidefields: false,
    };
  },
  computed: {
    canProceedToStep3() {
      // If there are no videos, only document needs to be completed
      if (this.videolist.length === 0) {
        return this.docCompleted;
      }
      return this.videoCompleted && this.docCompleted;
    },
    allConsentsChecked() {
      return this.consentChecks.readComprehend &&
             this.consentChecks.voluntary &&
             this.consentChecks.copyReceived &&
             this.consentChecks.healthInfo;
    },
    docProgress() {
      return this.docProgressValue;
    }
  },
async mounted() {
    store.dispatch("setNavbar", false);
    store.dispatch("setPatientNavbar", true);
 
    const wrapper = document.getElementById("page-wrapper");
    if (wrapper) {
      wrapper.style.width = "100%";
      wrapper.style.padding = "0";
      wrapper.style.overflowY = "auto";
 
      wrapper.style.height = "auto";
      wrapper.style.minHeight = "calc(100vh - 0px)";
    }
          const skipAccount = this.$route.query.skipAccount === "true";

  if (skipAccount) {
    this.currentStep = 2;
    this.updateTimeline(2);
    await this.initializeTrainingInfo();
    return;
  }
 
    const loginId = this.patientLoginId || this.$route.params.patientLoginId;
   
    if (loginId) {
      await this.checkIfPatientExists(loginId);
     
     
    }
  },
  async beforeUnmount() {
  
    if (this.videoTimer) {
    clearInterval(this.videoTimer);
  }
 
  const wrapper = document.getElementById("page-wrapper");
 
  if (wrapper) {
    wrapper.style.removeProperty("height");
    wrapper.style.removeProperty("min-height");
    wrapper.style.removeProperty("overflow-y");
    wrapper.style.removeProperty("padding");
    wrapper.style.removeProperty("width");
  }
  },
  watch: {
    docProgressValue(val) {
      if (val >= 85 && !this.docRead) {
        this.docRead = true;
        this.docCompleted = true;
      }
    },
    allConsentsChecked() {
      this.validateSignature();
    },
    "signature.email"() {
      this.validateSignature();
    },
    "signature.password"() {
      this.validateSignature();
    },
    videolist: {
      handler(val) {
        if (val.length === 0 && this.activeTab === 'video') {
          this.activeTab = 'doc';
        }
      },
      immediate: true
    }
  },
  methods: {
    // ========== PATIENT CHECK METHODS ==========
    // async checkIfPatientExists(loginId) {
    //   try {
    //     const idtoken = store.getters.getIdToken ? store.getters.getIdToken : "";

    //     const res = await axios.get(
    //       `${this.baseapi}/account-core/user/ispatientexist?patientLoginId=${loginId}`,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     const patientStatus = res.data;
    //     this.patient = patientStatus;

    //     console.log("patient is", this.patient);

    //     if (patientStatus === "User exist in patientlogin | Auth0 user found") {
    //       await this.getExistingPatientInfo(loginId);
    //       const tokenEmail = this.getTokenEmail(idtoken);
    //       const patientEmail = this.values.emailIdPrimary || this.patientInfo?.emailID || this.signature.email || "";

    //       if (!this.isSameEmail(tokenEmail, patientEmail)) {
    //         this.$router.push(
    //           `/subjectlogin/${this.patientLoginId}/${this.templateId}/${this.consentFormId}/${this.documentId}`
    //         );
    //         return;
    //       }

    //       this.hidefields = false;

    //       this.currentStep = 2;
    //       this.updateTimeline(2);

    //       await this.initializeTrainingInfo();
    //     } else {
    //       this.hidefields = true;
    //       await this.getExistingPatientInfo(loginId);
    //       await this.getPatientEmail(loginId);
    //     }
    //   } catch (err) {
    //     console.error("Error checking patient existence:", err);
    //   }
    // },
    async checkIfPatientExists(loginId) {
  try {
    const idtoken = store.getters.getIdToken ? store.getters.getIdToken : "";
    const res = await axios.get(
      `${this.baseapi}/account-core/user/ispatientexist?patientLoginId=${loginId}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    const patientStatus = res.data;
    this.patient = patientStatus;
    console.log("patient is", this.patient);

    if (patientStatus === "User exist in patientlogin | Auth0 user found") {
    
      this.$router.push(
        `/subjectlogin/${this.patientLoginId}/${this.templateId}/${this.consentFormId}/${this.documentId}`
      );
      return;
    } else {
      // Patient does not exist → show account creation (step 1)
      this.hidefields = true;
      await this.getExistingPatientInfo(loginId);
      await this.getPatientEmail(loginId);
    }
  } catch (err) {
    console.error("Error checking patient existence:", err);
  }
},

    async getExistingPatientInfo(loginId) {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseapi}/account-core/user/getencryptedpatientinfo?patientLoginId=${loginId}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.patientInfo = res.data;
        this.patientLogin = res.data;
        this.values.firstName = res.data.firstName || "";
        this.values.lastName = res.data.lastName || "";
        this.values.emailIdPrimary = res.data.emailID || "";
        this.signature.email = res.data.emailID || "";
        this.subjectId = res.data.subjectID || "";
        this.password = res.data.password || "";

        
        if (res.data.studyId) {
          this.studyId = res.data.studyId;
          store.dispatch("setStudyID", this.studyId);
        }
      } catch (err) {
        console.error("Error fetching patient info:", err);
      }
    },

    async getPatientEmail(loginId) {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseapi}/account-core/user/getencryptedpatientinfomail?patientLoginId=${loginId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.values.emailIdPrimary = res.data;
        this.signature.email = res.data;
      } catch (err) {
        console.log("Error getting patient email:", err);
      }
    },

    // ========== INITIALIZATION METHODS ==========
    async initializeTrainingInfo() {
      try {
        if (!this.patientInfo) {
          const loginId = this.patientLoginId || this.$route.params.patientLoginId;
          await this.getExistingPatientInfo(loginId);
        }
        
        await this.getPatientById();
        
        if (!this.studyId) {
          this.studyId = store.getters.getStudyID;
          if (!this.studyId) {
            console.error("Unable to retrieve studyId");
            return;
          }
        }
        
        await this.getDocuments();
        await this.getVideoList();
        await this.getDescription();
      } catch (error) {
        console.error("Error in initializeTrainingInfo:", error);
      }
    },

    async getPatientById() {
      if (this.studyId) {
        return;
      }
      
      const patientId = this.patientInfo?.subjectID || this.subjectId;
      
      if (!patientId) {
        return;
      }
      
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseapi}/management/patient/getpatientbyid/${patientId}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.patientItem = res.data;
        this.studyId = res.data.studyId || res.data.studyID || res.data.StudyId;
        
        if (this.studyId) {
          store.dispatch("setStudyID", this.studyId);
        }
      } catch (err) {
        console.error("Error getting patient item:", err);
      }
    },

    async getDescription() {
      if (!this.studyId) {
        this.isDescLoading = false;
        return;
      }
      
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseapi}/management/study/getstudydiscription?StudyId=${this.studyId}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.isDescLoading = false;
        this.description = res.data;
      } catch (err) {
        console.error("Error getting description:", err);
        this.isDescLoading = false;
      }
    },

    // ========== DOCUMENT METHODS ==========
async getDocuments() {
  const idtoken = store.getters.getIdToken;
  this.isDocumentLoading = true;

  const subjectId = this.subjectId || this.patientInfo?.subjectID || this.patientLogin?.subjectID;
  
  if (!subjectId) {
    console.error("Cannot get documents: subjectId is null");
    this.documentlist = [];
    this.isDocumentLoading = false;
    return false;
  }

  try {
    const response = await axios.get(
      `${this.baseapi}/management/patientdocument/listconsentformbystudy?StudyId=${this.studyId}&subjectId=${subjectId}&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}&consentRecordId=${this.consentFormId}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    // Get results from the response
    const documents = response.data.results || response.data.data || response.data || [];
    this.documentlist = Array.isArray(documents) ? documents : [];

    if (this.documentlist && this.documentlist.length > 0) {
      const finalResponseDocument = this.documentlist.find((document) => this.hasSubjectFinalResponseEvent(document));
      const doc = finalResponseDocument || this.documentlist[0];
      console.log("First document:", doc);
      
      // Extract icfFormId from the icf object
      if (doc.icf) {
        this.icfFormId = doc.icf.icfFormId;
        this.documentName = doc.icf.title || "Informed Consent Form";
        this.currentformid = doc.consentRecordId || doc.eCRFFormId || this.consentFormId;
        
        console.log("Extracted icfFormId:", this.icfFormId);
        console.log("Document name:", this.documentName);
        
        // View the document using icfDocumentId
        await this.viewDocument(
          doc.icf.icfDocumentId, 
          doc.icf.version || 0,
          doc.icf
        );
      } else {
        console.error("No icf object found in document:", doc);
      }

      if (finalResponseDocument) {
        this.showFinalResponseScreen(finalResponseDocument, true);
        return true;
      }
    }
  } catch (error) {
    console.error("Error fetching documents:", error);
    this.documentlist = [];
    return false;
  } finally {
    this.isDocumentLoading = false;
  }

  return false;
},

    hasSubjectSignedEvent(document) {
      return Boolean(this.getSubjectSignedEvent(document));
    },

    getSubjectSignedEvent(document) {
      return this.getSubjectEvent(document, "SUBJECT_SIGNED");
    },

    hasSubjectFinalResponseEvent(document) {
      return Boolean(this.getSubjectFinalResponseEvent(document));
    },

    getSubjectEvent(document, eventType) {
      const events = document?.events || [];
      if (!Array.isArray(events)) {
        return null;
      }

      return events.find((event) => event?.eventType === eventType) || null;
    },

    getSubjectFinalResponseEvent(document) {
      const events = document?.events || [];
      if (!Array.isArray(events)) {
        return null;
      }

      return events
        .filter((event) => event?.eventType === "SUBJECT_SIGNED" || event?.eventType === "SUBJECT_DISSENTED")
        .sort((left, right) => new Date(right.eventAt || 0) - new Date(left.eventAt || 0))[0] || null;
    },

    formatResponseDate(eventAt) {
      if (!eventAt) {
        return "";
      }

      const responseDate = new Date(eventAt);
      if (Number.isNaN(responseDate.getTime())) {
        return "";
      }

      const dateText = responseDate.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      const timeText = responseDate.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      const offsetMinutes = -responseDate.getTimezoneOffset();
      const offsetSign = offsetMinutes >= 0 ? "+" : "-";
      const absoluteOffset = Math.abs(offsetMinutes);
      const offsetHours = String(Math.floor(absoluteOffset / 60)).padStart(2, "0");
      const offsetRemainder = String(absoluteOffset % 60).padStart(2, "0");

      return `${dateText} at ${timeText} (UTC${offsetSign}${offsetHours}:${offsetRemainder})`;
    },

    showFinalResponseScreen(document, fromHistory = false) {
      const responseEvent = this.getSubjectFinalResponseEvent(document);
      const responseType = responseEvent?.eventType === "SUBJECT_DISSENTED" ? "dissented" : "signed";

      if (document?.icf) {
        this.icfFormId = document.icf.icfFormId;
        this.documentName = document.icf.title || "Informed Consent Form";
      }

      this.currentformid = document?.consentRecordId || document?.eCRFFormId || this.consentFormId;
      this.consentSigned = true;
      this.alreadySignedFromHistory = fromHistory;
      this.consentResponseType = responseType;
      this.consentResponseAt = responseEvent?.eventAt || "";
      this.consentResponseAtText = this.formatResponseDate(this.consentResponseAt);
      this.subjectSignedAt = responseType === "signed" ? this.consentResponseAt : "";
      this.subjectSignedAtText = responseType === "signed" ? this.consentResponseAtText : "";
      this.docRead = true;
      this.docCompleted = true;
      this.docProgressValue = 100;
      this.videoCompleted = true;
      this.canSign = false;
      this.currentStep = 4;
      this.updateTimeline(4);
    },

    async getDocumentdetails(documentId, version = 0) {
      const idtoken = store.getters.getIdToken;
      if (!documentId) {
        console.warn("No documentId provided");
        return null;
      }

      try {
        const url = `${this.baseapi}/etmf/document/getdocumentdetails?documentId=${documentId}&version=${version}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${idtoken}`,
            "Content-Type": "application/json",
          },
        });

        console.log("Document details loaded:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching document details:", error);
        return null;
      }
    },

    async fetchDocumentSource(url) {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
          },
          responseType: "blob",
        });
        const contentType = response.headers['content-type'] || response.headers['Content-Type'];
        console.log("Document content type:", contentType);
        if (contentType && (contentType.includes('application/pdf') || contentType.includes('application/octet-stream'))) {
          return URL.createObjectURL(response.data);
        } else {
          console.warn("Received non-PDF content type:", contentType);
          return "";
        }
      } catch (error) {
        console.error("Error fetching document source:", error);
        return "";
      }
    },

    async viewDocument(formId, versionNumber, document) {
      if (!formId) {
        this.icfDocumentError = "No document ID provided";
        return;
      }
      
      try {
        this.isIcfDocumentLoading = true;
        this.icfDocumentError = "";
        
        if (this.selectedIcfDocumentObjectUrl) {
          URL.revokeObjectURL(this.selectedIcfDocumentObjectUrl);
        }
        
        const idtoken = store.getters.getIdToken;
        const version = versionNumber || 0;
        
        const docDetails = await this.getDocumentdetails(formId, version);
        
        let storageId = null;
        let versionId = null;
        
        if (docDetails && docDetails.document && docDetails.document.documentVersions && docDetails.document.documentVersions.length > 0) {
          const targetVersion = docDetails.document.documentVersions.find(v => v.version == version) || docDetails.document.documentVersions[0];
          storageId = targetVersion.storageId;
          versionId = targetVersion.versionId;
        }
        
        const primarySource = `${this.baseapi}/etmf/document/documentfile/${formId}?version=${version}`;
        console.log("Primary document source URL:", primarySource);
        
        let fallbackSource = null;
        if (storageId && versionId) {
          fallbackSource = `${process.env.VUE_APP_File_upload_URL}/document/file/${storageId}?versionId=${versionId}`;
        } else {
          fallbackSource = `${process.env.VUE_APP_File_upload_URL}/document/file/${formId}?versionid=${version}`;
        }

        let source = await this.fetchDocumentSource(primarySource);
        console.log("Document source from primary URL:", source);
        
        if (!source && fallbackSource) {
          source = await this.fetchDocumentSource(fallbackSource);
        }

        if (source) {
          this.selectedIcfDocumentSource = source;
          this.selectedIcfDocumentObjectUrl = source;
          this.documentName = document?.icf?.title || document?.formName || "Informed Consent Form";
        } else {
          this.icfDocumentError = "Unable to load document";
        }
      } catch (err) {
        console.error("Error in viewDocument:", err);
        this.icfDocumentError = "Failed to fetch document";
      } finally {
        this.isIcfDocumentLoading = false;
      }
    },

    // ========== VIDEO METHODS (from trainingMaterials) ==========
async getVideoList() {
  if (!this.studyId) {
    console.error("Cannot get video list: studyId is null");
    this.isLoading = false;
    return;
  }
  
  // Use icfFormId extracted from the document response
  if (!this.icfFormId) {
    console.error("Cannot get video list: icfFormId is null. Make sure getDocuments() ran first.");
    this.isLoading = false;
    return;
  }
  
  try {
    const idtoken = store.getters.getIdToken;
    // Use both studyId and icfFormId parameters
    const url = `${this.baseapi}/management/video/videolist?studyId=${this.studyId}&icfFormId=${this.icfFormId}`;
    console.log("Fetching videos from:", url);
    console.log("Using studyId:", this.studyId);
    console.log("Using icfFormId:", this.icfFormId);
    
    const res = await axios.get(url, {
      headers: { 
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json"
      }
    });
    
    this.isLoading = false;
    // The response data is in res.data.data
    this.videolist = res.data.data || [];
    console.log("Videos loaded:", this.videolist.length);
    
    if (this.videolist.length > 0) {
      console.log("First video:", this.videolist[0]);
    }
  } catch (err) {
    console.error("Error getting video list:", err);
    this.isLoading = false;
    this.videolist = [];
  }
},

    // Open modal to play video (from trainingMaterials)
    openModal(type, id, versionid, videoid, referenceId) {
      this.modalType = type;
      this.modelvideoId = videoid;
      this.versionId = versionid;
      this.Id = id;
      this.showModal = !this.showModal;
      this.ReferenceId = referenceId;
    },
    openVideoList() {
  if (this.videoCompleted || this.videoTimer) return;
},
playVideo(video) {
  this.selectedVideo = video;
  this.openModal('video', '', '', video.id);
  
  // Simulate video progress tracking
  if (this.videoTimer) clearInterval(this.videoTimer);
  this.videoTimer = setInterval(() => {
    this.videoProgress = Math.min(100, this.videoProgress + 2);
    this.vidPct = this.videoProgress;

    if (this.videoProgress >= 100) {
      clearInterval(this.videoTimer);
      this.videoTimer = null;
      this.videoCompleted = true;
      this.vidWatched = true;
      this.videoStatusText = "Video completed ✓";
      this.updateConsentBySubject("VIDEO_VIEWEDBY_SUBJECT");
      this.videoViewedEventSent = true;
    }
  }, 80);
},

// Add this method to close video modal
closeVideoModal() {
  this.videoModalVisible = false;
  this.selectedVideo = null;
},
jwtDecrypt(token) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    },
    getTokenEmail(token) {
      if (!token) {
        return "";
      }

      try {
        return jwt_decode(token).email || "";
      } catch (err) {
        console.warn("Unable to decode id token:", err);
        return "";
      }
    },
    normalizeEmail(email) {
      return (email || "").toString().trim().toLowerCase();
    },
    isSameEmail(left, right) {
      const normalizedLeft = this.normalizeEmail(left);
      const normalizedRight = this.normalizeEmail(right);
      return normalizedLeft !== "" && normalizedLeft === normalizedRight;
    },
    // Start video playback - opens the first video in modal
    // startVideo() {
    //   if (this.videoCompleted || this.videoTimer) return;

    //   // If there are videos in the list, open the first video in modal
    //   if (this.videolist.length > 0) {
    //     const firstVideo = this.videolist[0];
    //     this.openModal('video', '', '', firstVideo.id);
    //   } else {
    //     alert("No videos available to play.");
    //     return;
    //   }

    //   // Simulate video progress tracking
    //   this.videoTimer = setInterval(() => {
    //     this.videoProgress = Math.min(100, this.videoProgress + 2);
    //     this.vidPct = this.videoProgress;

    //     if (this.videoProgress >= 100) {
    //       clearInterval(this.videoTimer);
    //       this.videoTimer = null;
    //       this.videoCompleted = true;
    //       this.vidWatched = true;
    //       this.videoStatusText = "Video completed ✓";
    //     }
    //   }, 80);
    // },

    // ========== ACCOUNT CREATION METHODS ==========
    async continueToCreate() {
      const idtoken = store.getters.getIdToken ? store.getters.getIdToken : "";
      const tokenEmail = this.getTokenEmail(idtoken);

      if (!this.isSameEmail(tokenEmail, this.values.emailIdPrimary)) {
        await this.validate();
        await this.validateallpassword();

        if (this.validations.includes(false)) {
          this.errors = this.validations;
        } else {
          await this.createAccount();
        }
      } else {
        this.currentStep = 2;
        this.updateTimeline(2);
        await this.initializeTrainingInfo();
      }
    },

    async validate() {
      this.values.firstName = this.values.firstName.replace(/ +/g, ' ').trim();
      this.values.lastName = this.values.lastName.replace(/ +/g, ' ').trim();
      this.values.emailIdPrimary = this.values.emailIdPrimary.replace(/ +/g, ' ').trim();     
      this.Validatename(this.values.firstName, 0);
      this.Validatename(this.values.lastName, 1);
      this.ValidatefirstEmail(this.values.emailIdPrimary);     
    },

    async Validatename(name, errindex) {
      let letters = /^[A-Za-z\s]*$/;
      if (name.trim() == "") {
        this.validations[errindex] = false;
      } else if (!letters.test(name)) {
        this.validations[errindex] = true;
      } else {
        this.validations[errindex] = true;
      }
    },

    async ValidatefirstEmail(mail) {
      if(mail == "") {
        this.validations[2] = false;
        this.validations[7] = true;
      } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        this.validations[7] = true;
        this.validations[2] = true;       
      } else {
        this.validations[7] = false;
        this.validations[2] = true;
      }
    },

    async passwordVisible() {
      this.visibleOn = !this.visibleOn;
      this.inputType = this.visibleOn ? "text" : "password";
    },

    async validateallpassword() {
      this.Validatepassword(this.values.password);
      this.Validateconfirmpassword(this.newpassword);
      this.Validatematchpasswords(this.newpassword, this.values.password);
    },

    async Validatepassword(passwd) {
      let reNum = /[0-9]/;
      let reLow = /[a-z]/;
      let reUpp = /[A-Z]/;
      let spcl = /(?=.*[!@#$%^&*])/;
      
      if (passwd == "" || passwd == null) {
        this.validations[6] = true;
        this.validations[3] = false;
      } else if (passwd.length < 8 && !reLow.test(passwd) || !reNum.test(passwd) || !spcl.test(passwd) || !reUpp.test(passwd)) {
        this.validations[3] = true;
        this.validations[6] = false;
      } else {
        this.validations[3] = true;
        this.validations[6] = true;
      }
    },

    async Validateconfirmpassword(passwd) {
      if (passwd == "" || passwd == null) {
        this.validations[4] = false;
      } else {
        this.validations[4] = true;
      }
    },

    async Validatematchpasswords(passwd, confirmpaswd) {
      if (this.validations[3] == true && this.validations[4] == true && this.validations[6] == true) {
        if (passwd == confirmpaswd) {
          this.validations[5] = true;
        } else {
          this.validations[5] = false;
        }
      } else {
        this.validations[5] = true;
      }
    },

    async createAccount() {
      if (!this.values.firstName || !this.values.lastName || !this.values.password) {
        alert("Please fill all required fields");
        return;
      }
      if (this.values.password !== this.newpassword) {
        alert("Passwords do not match");
        return;
      }
      
      this.accountLoading = true;
      try {
        const idtoken = store.getters.getIdToken;
        const loginId = this.patientLoginId || this.$route.params.patientLoginId;
        const payload = {
          firstName: this.values.firstName,
          lastName: this.values.lastName,
          userName: this.values.userName,
          emailIdPrimary: this.values.emailIdPrimary,
          password: this.values.password,
          timeZone: this.values.timeZone,
          preferredLanguage: this.values.preferredLanguage,
          patientLoginId: loginId
        };
        
        const res = await axios.post(
          `${this.baseapi}/account-core/user/createsubject`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        await store.dispatch("loginuser", res.data);
        console.log("tokenis", store.getters.getIdToken);
        alert("User created successfully.");
        
        await this.getExistingPatientInfo(loginId);
        await this.initializeTrainingInfo();
        
        this.currentStep = 2;
        this.updateTimeline(2);
        
      } catch (err) {
        const errorMsg = err.response?.data?.message || err.response?.data || err.message;
        alert("Error creating account: " + errorMsg);
      } finally {
        this.accountLoading = false;
      }
    },

    // ========== NAVIGATION METHODS ==========
    goToStep(step) {
  if (step === 1 && this.currentStep > 1) {
    // Navigating back to account creation from a later step
    if (this.patientInfo) {
      // Patient already exists → hide password fields
      this.hidefields = false;
      // Clear any previously entered passwords for security
      this.values.password = "";
      this.newpassword = "";
    } else {
      // Patient does not exist (rare case) → show password fields
      this.hidefields = true;
    }
    this.currentStep = 1;
    this.updateTimeline(1);
  } 
  else if (step === 2 && (this.timelineSteps[0].status === "done" || this.patientInfo?.id)) {
    this.currentStep = 2;
    this.updateTimeline(2);
  } 
  else if (step === 3 && this.consentSigned) {
    this.currentStep = 4;
    this.updateTimeline(4);
  } 
  else if (step === 3 && this.canProceedToStep3) {
    this.currentStep = 3;
    this.updateTimeline(3);
  } 
  else if (step === 2 && !this.canProceedToStep3) {
    if (this.videolist.length === 0 && !this.docCompleted) {
      alert("Please complete the document review before proceeding.");
    } else if (this.videolist.length > 0 && (!this.videoCompleted || !this.docCompleted)) {
      alert("Please complete the video and document review before proceeding.");
    }
  }
},
    // goToStep(step) {
    //   if (step === 1 && this.currentStep > 1) {
    //     this.currentStep = 1;
    //     this.updateTimeline(1);
    //   } else if (step === 2 && (this.timelineSteps[0].status === "done" || this.patientInfo?.id)) {
    //     this.currentStep = 2;
    //     this.updateTimeline(2);
    //   } else if (step === 3 && this.consentSigned) {
    //     this.currentStep = 4;
    //     this.updateTimeline(4);
    //   } else if (step === 3 && this.canProceedToStep3) {
    //     this.currentStep = 3;
    //     this.updateTimeline(3);
    //   } else if (step === 2 && !this.canProceedToStep3) {
    //     if (this.videolist.length === 0 && !this.docCompleted) {
    //       alert("Please complete the document review before proceeding.");
    //     } else if (this.videolist.length > 0 && (!this.videoCompleted || !this.docCompleted)) {
    //       alert("Please complete the video and document review before proceeding.");
    //     }
    //   }
    // },

    goToStudyDetailsFromSuccess() {
      this.activeTab = "doc";
      this.currentStep = 2;
      this.updateTimeline(2);
    },

    updateTimeline(step) {
      for (let i = 0; i < 3; i++) {
        if (i < step - 1) {
          this.timelineSteps[i].status = "done";
          if (i < 2) this.timelineSteps[i].lineStatus = "done";
        } else if (i === step - 1) {
          this.timelineSteps[i].status = "active";
          if (i < 2) this.timelineSteps[i].lineStatus = "";
        } else {
          this.timelineSteps[i].status = "";
          if (i < 2) this.timelineSteps[i].lineStatus = "";
        }
      }
    },

    // ========== DOCUMENT SCROLL METHODS ==========
    trackDoc(event) {
      const el = event.target;
      const total = el.scrollHeight - el.clientHeight;
      
      if (total <= 0) return;
      
      const pct = Math.min(100, Math.round((el.scrollTop / total) * 100));
      this.docProgressValue = pct;
      
      const page = Math.min(7, Math.max(1, Math.round((pct / 100) * 6) + 1));
      this.pageIndicator = `Page ${page} of 7`;
      
      if (pct >= 85 && !this.docRead) {
        this.docRead = true;
        this.docCompleted = true;
      }
       if (pct >= 100 && !this.documentViewedEventSent) {
    this.documentViewedEventSent = true;
    this.updateConsentBySubject("SUBJECT_VIEWED");
  }
    },

    switchTab(tab) {
      this.activeTab = tab;
    },

    // ========== CONSENT SIGNING METHODS ==========
    // validateSignature() {
    //   this.canSign = this.allConsentsChecked &&
    //     this.signature.email.trim() !== "" &&
    //     this.signature.password.trim() !== "";
    // },
    validateSignature() {
  this.canSign = this.consentAgreed === 'yes' &&
    this.allConsentsChecked &&
    this.signature.email.trim() !== "" &&
    this.signature.password.trim() !== "";
},
  onConsentChange() {
    // Reset consent checks if user changes from Yes to No or vice versa
    if (this.consentAgreed === 'no') {
      this.consentChecks = {
        readComprehend: false,
        voluntary: false,
        copyReceived: false,
        healthInfo: false
      };
      this.signature = { email: this.values.emailIdPrimary || "", password: "" };
    }
    this.validateSignature();
  },

    async doSign() {
      if (!this.canSign || this.isSigning) return;
      this.isSigning = true;
      
      try {
        const idtoken = store.getters.getIdToken;
        const loginId = this.patientLoginId || this.$route.params.patientLoginId;
        const formId = this.currentformid || this.consentFormId || this.documentlist[0]?.formId || "";
        const status = "Consented";
        
        //await this.updateConsentBySubject("SUBJECT_VIEWED");
        
        await axios.put(
          `${this.baseapi}/account-core/user/signconsentform?loginId=${loginId}&status=${status}&email=${this.signature.email}&password=${this.signature.password}&consentRecordId=${formId}`,
          {},
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        
        await this.updateConsentBySubject("SUBJECT_SIGNED");
        
        this.timelineSteps[2].status = "done";
        this.consentSigned = true;
        this.alreadySignedFromHistory = false;
        this.subjectSignedAt = "";
        this.subjectSignedAtText = "";
        this.consentResponseType = "signed";
        this.consentResponseAt = "";
        this.consentResponseAtText = "";
        this.currentStep = 4;
        this.updateTimeline(4);
        
        // setTimeout(() => {
        //   this.$router.push("/acknowledgement");
        // }, 3000);
      } catch (err) {
        const errorMsg = err.response?.data?.errors?.DomainValidations?.[0] || "Signing failed. Please try again.";
        alert(errorMsg);
      }
      finally {
    this.isSigning = false;
  }
    },

    // async updateConsentBySubject(status) {
    //   const idtoken = store.getters.getIdToken;
    //   const consentId = this.currentformid || this.consentFormId || "";
    //   const studyID = this.studyId || store.getters.getStudyIs || "";
    //   const subjectID = this.subjectId || this.patientInfo?.subjectID || "";

    //   if (!consentId || !studyID || !subjectID) {
    //     console.warn("Skipping updateConsentBySubject: missing required identifiers");
    //     return;
    //   }

    //   const payload = {
    //     consentId,
    //     studyID,
    //     subjectID,
    //     status: status,
    //     ipAddress: "",
    //     device: "",
    //     browser: "",
    //     os: "",
    //     location: "",
    //     signatureType: "",
    //     signatureReason: "",
    //     comments: "",

    //     role: "",
        
    //     consentFormViewStatus: true,
    //     consentFormViewedDate: new Date().toISOString(),
    //   };

    //   try {
    //     await axios.put(
    //       `${this.baseapi}/management/patientdocument/updateconsentbysubject`,
    //       payload,
    //       { headers: { Authorization: "Bearer " + idtoken } }
    //     );
    //     console.log(`Updated consent status to: ${status}`);
    //   } catch (err) {
    //     console.error("Error updating consent status:", err);
    //   }
    // },
    async updateConsentBySubject(status, dissentReason = null) {
  const idtoken = store.getters.getIdToken;
  const consentId = this.currentformid || this.consentFormId || "";
  const studyID = this.studyId || store.getters.getStudyIs || "";
  const subjectID = this.subjectId || this.patientInfo?.subjectID || "";

  if (!consentId || !studyID || !subjectID) {
    console.warn("Skipping updateConsentBySubject: missing required identifiers");
    return;
  }

  const payload = {
    consentId,
    studyID,
    subjectID,
    status: status,
    ipAddress: "",
    device: "",
    browser: "",
    os: "",
    location: "",
    signatureType: "",
    signatureReason: "",
    comments: "",
    role: "",
    consentFormViewStatus: true,
    consentFormViewedDate: new Date().toISOString(),
  };

  // Only add dissentReason when status is DISSENTED and reason is provided
  if (status === "SUBJECT_DISSENTED" && dissentReason) {
    payload.dissentReason = dissentReason;
  }

  try {
    await axios.put(
      `${this.baseapi}/management/patientdocument/updateconsentbysubject`,
      payload,
      { headers: { Authorization: "Bearer " + idtoken } }
    );
    console.log(`Updated consent status to: ${status}`);
  } catch (err) {
    console.error("Error updating consent status:", err);
  }
},

    // ========== UTILITY METHODS ==========
    zoomDocument() { 
      alert("Zoom feature would be implemented here"); 
    },
    
    searchDocument() { 
      alert("Search feature would be implemented here"); 
    },
    
    downloadDocument() {
      if (this.selectedIcfDocumentSource) {
        const link = document.createElement("a");
        link.href = this.selectedIcfDocumentSource;
        link.download = this.documentName || "consent_form.pdf";
        link.click();
      }
    },
    async loadDocument() {
  if (!this.icfDocumentId) {
    this.icfDocumentError = "No document ID available";
    this.isIcfDocumentLoading = false;
    return;
  }
  
  try {
    // Show loader
    this.isIcfDocumentLoading = true;
    this.icfDocumentError = "";
    
    // Clear previous document URL
    if (this.selectedIcfDocumentObjectUrl) {
      URL.revokeObjectURL(this.selectedIcfDocumentObjectUrl);
      this.selectedIcfDocumentSource = "";
      this.selectedIcfDocumentObjectUrl = "";
    }
    
    const idtoken = store.getters.getIdToken;
    const version = 0;
    
    // Build the document URL
    const documentUrl = `${this.baseapi}/etmf/document/documentfile/${this.icfDocumentId}?version=${version}`;
    console.log("Loading document from:", documentUrl);
    
    // Fetch the document
    const response = await axios.get(documentUrl, {
      headers: { 
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json"
      },
      responseType: "blob"
    });
    
    const contentType = response.headers['content-type'] || response.headers['Content-Type'];
    console.log("Document content type:", contentType);
    
    // Check if the response is a PDF
    if (contentType && (contentType.includes('application/pdf') || contentType.includes('application/octet-stream'))) {
      // Create object URL from the blob
      const blobUrl = URL.createObjectURL(response.data);
      this.selectedIcfDocumentSource = blobUrl;
      this.selectedIcfDocumentObjectUrl = blobUrl;
      console.log("Document loaded successfully");
    } else {
      this.icfDocumentError = "Document is not a valid PDF format";
    }
  } catch (err) {
    console.error("Error loading document:", err);
    this.icfDocumentError = err.response?.data?.message || "Failed to load document. Please try again.";
  } finally {
    // Hide loader
    this.isIcfDocumentLoading = false;
  }
},

// Retry loading document
async retryLoadDocument() {
  console.log("Retrying document load...");
  await this.loadDocument();
},
async submitNoConsent() {
  if (this.isSubmittingNoConsent) return;

  // Trim the reason and validate
  const reason = this.signingReason?.trim();
  if (!reason) {
    this.dissentReasonError = true;
    return;
  }
  this.dissentReasonError = false;

  this.isSubmittingNoConsent = true;
  try {
    const idtoken = store.getters.getIdToken;
    const consentRecordId = this.currentformid || this.consentFormId || this.documentlist[0]?.consentRecordId || "";
    
    if (!consentRecordId) {
      alert("Unable to submit: Consent record ID not found.");
      return;
    }

    const url = `${this.baseapi}/account-core/user/consentdissent?id=${consentRecordId}`;
    const dissentReason = reason;   // use the validated reason
    
    const response = await axios.put(url, { dissentReason }, {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    });

    if (response.data) {
      await this.updateConsentBySubject("SUBJECT_DISSENTED", dissentReason);
      
      this.noConsentSubmitted = true;
      this.consentSigned = true;
      this.alreadySignedFromHistory = false;
      this.consentResponseType = "dissented";
      this.consentResponseAt = "";
      this.consentResponseAtText = "";
      alert("Your response has been submitted. Thank you for your consideration.");
      this.timelineSteps[2].status = "done";
      this.currentStep = 4;
      this.updateTimeline(4);
    }
  } catch (err) {
    console.error("Error submitting no consent:", err);
    const errorMsg = err.response?.data?.message || err.response?.data?.errors?.[0] || "Failed to submit. Please try again.";
    alert(errorMsg);
  } finally {
    this.isSubmittingNoConsent = false;
  }
},
  }
};
